<template>
  <div class="yunxiao teacher clue recycle-bin">
    <search-filter-new
      :items="searchItems"
      :campus="params.campusList"
      placeholder="输入姓名/手机号后四位"
      @onBatch="operationMode = !operationMode"
      @onCampus="chooseCampus"
      @onSearch="params.keyWord = $event"
    >
    </search-filter-new>
    <search-filter-new @change="filterChange">
      <filter-item kind="yq-排序" :value="this.params.orderByType"></filter-item>
      <div
        class="shortcut-item has-down-icon"
        :class="{ 'has-filter': params.recoveryTeacherIds.length }"
        @click="chooseAbandonTeacher"
      >
        放弃操作人
      </div>
      <sideFilterItem :hasFilter="hasFilter" @clickFilter="openFilter" />
    </search-filter-new>
    <div class="list-number-line" v-if="list.length">
      <div class="add-area__info">意向数量：{{ totalCount }}</div>
    </div>
    <vx-list
      class="clue-item-wrapper"
      enable
      :api="api"
      :params="queryParams"
      @load="onLoad"
      ref="listScroller"
    >
      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        description="没有找到意向"
        v-if="list.length === 0 && !loading"
        image-size="128"
        style="padding-top: 50px"
      >
      </van-empty>
      <clue-item
        v-for="item of list"
        :infos="item"
        :isCheckMode="operationMode"
        @clickItem="clickItemHandler(item)"
        :isRecycleBin="true"
        :key="item.id"
      />
    </vx-list>

    <div class="footer" v-if="operationMode">
      <div class="choosed-status">
        <div class="checked-nav" :class="{ 'all-checked': allChecked }">
          <van-checkbox
            @change="allCheckBoxChange"
            v-model="allChecked"
            icon-size="var(--fs-lg)"
          />全选
        </div>
        <!-- <span class="choosed-num" >已选:<span>{{ choosedNum }}</span></span> -->
      </div>
      <van-button
        class="ccbtn"
        square
        round
        block
        @click="operationMode = false"
        style="margin-right: calc(var(--gap) * 12); min-width: calc(var(--gap) * 72)"
      >
        取消
      </van-button>
      <van-button class="cnbtn" square round block type="primary" @click="toShowOpMark">
        编辑({{ choosedList.length }}/{{ total }})
      </van-button>
    </div>

    <van-action-sheet
      v-model="showOpMark"
      :actions="moreOperations"
      cancel-text="取消"
      close-on-click-action
      @cancel="showOpMark = false"
      @select="onSelectOpMark"
    >
    </van-action-sheet>
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import clueItem from './children/clue-item.vue';
import FilterItem from '@x3/vue/comp/filter-item.vue';
import sideFilterItem from '@x3/vue/filter-comps/side-filter.vue';
import { openClueFilter } from './clue-filter/index.js';
export default {
  name: 'clueRecycleBin',
  components: {
    SearchFilterNew,
    FilterItem,
    sideFilterItem,
    clueItem,
  },
  data() {
    return {
      pageTitle: '意向回收站',
      params: {
        keyWord: '',
        // 校区ID集合
        campusIds: [],
        campusList: [],
        comeFroms: [],
        followTeacherIds: [],
        createTeacherIds: [],
        recoveryTeacherIds: [],
        abandonTeacherList: [],
        status: [3],
        startRecoveryTime: '',
        endRecoveryTime: '',
        startCreateTime: '',
        endCreateTime: '',
        startAge: '',
        endAge: '',
        orderByType: '',
      },
      list: [],
      total: 0,
      api: this.$api.clueAllPage,
      loading: true,
      operationMode: false,
      allChecked: false,
      startDate: '',
      endDate: '',
      showOpMark: false,
    };
  },
  computed: {
    // 当前是否有筛选
    hasFilter: function () {
      let lens = [
        this.params.comeFroms.length,
        this.params.followTeacherIds.length,
        this.params.startRecoveryTime.length,
        this.params.endRecoveryTime.length,
        this.params.startCreateTime.length,
        this.params.endCreateTime.length,
        this.params.createTeacherIds.length,
        this.params.recoveryTeacherIds.length,
        this.params.startAge.length,
        this.params.endAge.length,
        this.params.keyWord.length,
      ];
      let len = lens.reduce((cur, pre) => (cur += pre));
      if (len > 0) {
        return true;
      } else {
        return false;
      }
    },
    moreOperations() {
      let actions = [];
      if (app.permission.op('delete_intention_clue')) {
        actions.push({ name: '删除', id: 1 });
      }
      if (app.permission.op('reback_intention_clue')) {
        actions.push({ name: '恢复', id: 2 });
      }
      return actions;
    },
    searchItems() {
      let arr = ['campus', 'search'];
      if (
        app.permission.op('delete_intention_clue' || 'reback_intention_clue') &&
        !this.operationMode
      ) {
        arr.push('batch');
      }
      return arr;
    },
    queryParams() {
      let params = { ...this.params };
      delete params.campusList;
      delete params.createTeacherList;
      delete params.followTeacherList;
      delete params.abandonTeacherList;
      return params;
    },
    choosedList() {
      return this.list.filter(v => v.checked);
    },
    choosedNum() {
      return this.choosedList.length;
    },
    cluesIds() {
      return this.choosedList.filter(v => v.checked).map(v => v.id);
    },
  },
  methods: {
    filterChange(data) {
      Object.assign(this.params, data);
    },
    onSelectOpMark(val) {
      if (val.id === 1) {
        this.deleteClues();
      }
      if (val.id === 2) {
        this.resetClues();
      }
    },
    onLoad(list, res) {
      vant.Toast.clear();
      this.list = list;
      this.total = res.page.totalCount;
      this.loading = false;
      this.totalCount = res && res.page && res.page.totalCount;
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
        config: {
          enableZero: true,
          zeroName: '未分配校区',
        },
        defaultParams: {
          status: [3],
        },
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    // 选择放弃操作人
    async chooseAbandonTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.recoveryTeacherIds,
        list: this.params.abandonTeacherList,
      });

      this.params.recoveryTeacherIds = res.ids;
      this.params.abandonTeacherList = res.list;
      // this.noFollowTeacher = false;
    },
    // 打开筛选
    async openFilter() {
      let res = await openClueFilter({
        params: this.params,
        config: {
          noFollowTeacher: true,
          hideStatus: true,
          hideFollowStatus: true,
          showNextDate: false,
          showAbandonTeacher: true,
          showDateRange: true,
          businessType: 'STUDENT_INTENTION', 
        },
        defaultParams: {
          status: [3],
        },
      });
      this.showLoading();
      this.params = Object.assign(this.params, {
        ...res.params,
        ageFrom: res.params.startAge,
        ageTo: res.params.endAge,
      });
    },
    clickItemHandler(item) {
      this.operationMode
        ? this.$set(item, 'checked', !Boolean(item.checked))
        : this.$router.push(`/cluedetails?id=${item.id}`);
    },
    allCheckBoxChange(val) {
      // 避免通过点击单个，到达全选状态
      // 还会循环一遍实现选中的问题
      if (val && this.list.length !== this.choosedNum) {
        this.list.forEach(v => {
          if (v && !v.checked) {
            this.$set(v, 'checked', val);
          }
        });
      }
      // 取消全选,避免通过点击单个，到达未全选状态
      // 还会循环一遍取消所有选中的问题
      if (!val && this.list.length === this.choosedNum) {
        this.list.forEach(v => {
          this.$set(v, 'checked', val);
        });
      }
    },
    deleteClues() {
      let { choosedList, choosedNum } = this;
      if (choosedList.length <= 0) {
        this.$toast('请选择要批量删除的意向');
        return false;
      }
      this.$dialog
        .confirm({
          className: 'clue-recycle-dialog',
          title: '提示',
          messageAlign: 'left',
          message:
            choosedNum > 1
              ? `${choosedList[0].name}等${choosedNum}条意向将被彻底删除，意向相关的信息都不会保留，是否确认删除？`
              : `${choosedList[0].name}将被彻底删除，意向相关的信息都不会保留，是否确认删除？`,
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          confirmButtonColor: 'var(--c3)',
        })
        .then(() => {
          this.toDeleteClues();
        })
        .catch(() => {});
    },
    toDeleteClues() {
      let { cluesIds } = this;
      this.showLoading();
      this.$api
        .deleteClues({ clueIds: cluesIds, needCheck: true })
        .then(res => {
          if (res.code === 200) {
            this.$refs['listScroller'].refresh();
            this.$toast.success('操作成功');
            return false;
          }
          if (res.code === 810000005) {
            let len = res.data.intentionClueDos.length;
            let name = res.data.intentionClueDos[0].name;
            let nameInfos = `未找到${
              len === 1 ? name : `${name}等${len}条意向`
            },请重新选择需要分配的意向`;
            this.$toast(nameInfos);
            return false;
          }

          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err => {
          if (!err.code) {
            this.$toast.clear();
          }
        });
    },
    resetClues() {
      let { choosedList, choosedNum } = this;
      if (choosedList.length <= 0) {
        this.$toast('请选择要批量恢复的意向');
        return false;
      }
      this.$dialog
        .confirm({
          className: 'clue-recycle-dialog',
          title: '提示',
          messageAlign: 'left',
          message:
            choosedNum > 1
              ? `${choosedList[0].name}等${choosedNum}条意向将被恢复至“待清洗意向”，可进行再次分配，是否恢复意向？`
              : `${choosedList[0].name}将被恢复至“待清洗意向”，可进行再次分配，是否恢复意向？`,
          confirmButtonText: '恢复意向',
          cancelButtonText: '取消',
        })
        .then(() => {
          this.toResetClues();
        })
        .catch(() => {});
    },
    toResetClues() {
      let { cluesIds } = this;
      this.showLoading();
      this.$api
        .clueResumeClue({ clueIds: cluesIds, needCheck: true })
        .then(res => {
          if (res.code === 200) {
            this.$toast.success('操作成功');
            this.$refs['listScroller'].refresh();
            return false;
          }
          if (res.code === 810000005) {
            let len = res.data.intentionClueDos.length;
            let name = res.data.intentionClueDos[0].name;
            let nameInfos = `未找到${
              len === 1 ? name : `${name}等${len}条意向`
            },请重新选择需要分配的意向`;
            this.$toast(nameInfos);
            return false;
          }

          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err => {
          if (!err.code) {
            this.$toast.clear();
          }
        });
    },
    toShowOpMark() {
      let { choosedList } = this;
      if (choosedList.length <= 0) {
        this.$toast('请选择要批量恢复的意向');
        return false;
      }
      this.showOpMark = true;
    },
    refreshList() {
      this.$refs['listScroller'] && this.$refs['listScroller'].refresh();
    },
  },
  created() {
    this.$onBus('delete-clues-success', this.refreshList);
    this.$onBus('resume-clues-success', this.refreshList);
  },
  beforeDestroy() {},
  watch: {
    params() {
      this.loading = true;
    },
    // 选中的条数发生变化(通过单个点击引起)
    choosedNum(v) {
      let len = this.list.length;
      if (len === 0) {
        this.allChecked = false;
        return false;
      }
      // 当选中条数不等于所有可选条数，取消全选状态
      if (v !== len) this.allChecked = false;
      // 当选中条数等于所有可选条数，标记为全选状态
      if (v === len) this.allChecked = true;
    },
    // 取消批量操作模式，清除选中
    operationMode(v) {
      if (v === false) {
        this.choosedList.forEach(e => this.$set(e, 'checked', false));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.clue.recycle-bin {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .link-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--tlc);
  }
  .clue-item-wrapper {
    flex: 1;
    overflow-y: auto;
  }
  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-button {
      min-width: 20px;
      height: calc(var(--w) * 40);
      padding: 0 8px;
    }
    .ccbtn {
      flex: 2;
    }
    .cnbtn {
      flex: 5;
    }
    .choosed-status {
      flex: 1;
      white-space: nowrap;

      .checked-nav {
        margin-right: calc(var(--gap) * 16);
        display: flex;
        align-items: center;
        color: var(--g6);
        > div {
          margin-right: calc(var(--gap) * 4);
        }
        &.all-checked {
          color: var(--g8);
        }
      }
    }
  }
}
</style>